import { siteService } from "../../../services/SiteService";

export default {
    name: "Offers",

    components: {},

    props: {},

    data: () => {
        return {
            offers: []
        };
    },
    created() {
        siteService.getProoOffers().then(response => {
            this.offers = response.data;
            console.log(this.offers);
        });
    },

    computed: {},

    methods: {
        getImageByCode(offer) {
            return {
                Prop: offer.Code === "Prop",
                CASCO: offer.Code === "CASCO",
                CMR: offer.Code === "CMR",
                ROTr: offer.Code === "ROTr"
            };
        },

        getRouteByCode(offer) {
            switch (offer.Code) {
                case "Prop":
                    return { path: "/order/add/2?step=0" };
                case "CASCO":
                    return { path: "/order/add/3?step=0" };
                case "CMR":
                    return { path: "/#contact" };
                case "ROTr":
                    return { path: "/#contact" };
                default:
                    return { path: "/#contact" };
            }
        }
    }
};
